import Vue from 'vue'
import Router from 'vue-router'
import login from './Login.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/index',
      beforeEnter (to, from, next) {
        location.replace(process.env.BASE_URL + 'index.html#/index')
      }
    },
    {
      path: '/message',
      beforeEnter (to, from, next) {
        location.replace(process.env.BASE_URL + 'message')
      }
    },
    {
      path: '',
      component: login
    },
    {
      path: '/login',
      component: login
    }
  ]
})
